import './featuredpublication.less'
import m from 'mithril'
import {t} from 'store'
import {Component, action, Image, classes} from '@codeurs/front'
import PublicationImage from './publicationimage'
import {PublicationType} from './publicationlink'
import Link from 'views/layout/link'
import Wysiwyg from 'views/layout/wysiwyg'
import downloadImage from 'assets/icons/downloadicon.png'
import Button from 'views/layout/button'
import {getAllThemesFromLists, getAllTagsFromLists} from 'util/tags'
import TagLink from 'views/layout/taglink'

export default class FeaturedPublication extends Component<{
	featured: PublicationType
	mod?: string
	lists?: any
	channel?: string
}> {
	view() {
		if (!this.attrs.featured || Array.isArray(this.attrs.featured)) return
		const {
			author,
			url,
			label,
			description,
			title,
			publication_file,
			publication_subtitle,
			publication_title,
			tags,
			sector,
			policy
		} = this.attrs.featured
		const {mod, channel} = this.attrs
		const modTags = ['article', 'publication'].indexOf(mod) >= 0
		return m('.featuredpublication', [
			m('.featuredpublication-inner', classes({mod}), [
				m('.featuredpublication-inner-top', [
					m(PublicationImage, {
						publication_subtitle,
						publication_title,
						label,
						featured: true,
						hasClass: 'featuredpublication-inner-top-image'
					}),
					m('.featuredpublication-inner-top-info', [
						m('.featuredpublication-inner-top-info-top', [
							m('.featuredpublication-inner-top-info-top-copy',
								this.getCopy(channel, label[0])
							),
							publication_file &&
								m('.featuredpublication-inner-top-info-top-size',
									publication_file.size
								)
						]),
						author &&
							m('.featuredpublication-inner-top-info-author',
								t('publications.written') + ' ' + author.title
							)
					]),
					channel != 'publication' &&
						m('.featuredpublication-inner-top-content', [
							title &&
								m('h2.featuredpublication-inner-top-content-title', title),
							description &&
								m(Wysiwyg, {
									class: 'featuredpublication-inner-top-content-text',
									html: description
								}),
							m(Link,
								{
									...action(url),
									...classes(
										{mod: 'blue'},
										'featuredpublication-inner-top-content-link'
									)
								},
								[
									m('.featuredpublication-inner-top-content-link-text',
										t('articles.readmore')
									),
									m('.featuredpublication-inner-top-content-link-arrow', '>')
								]
							)
						])
				]),
				publication_file && m('.featuredpublication-line'),
				publication_file &&
					publication_file &&
					m('.featuredpublication-inner-bottom', [
						m(Button,
							{
								mod: 'more flexcontent 3dhover',
								class: 'featuredpublication-inner-bottom-button',
								...action(publication_file.url)
							},
							[
								m('.featuredpublication-inner-bottom-text',
									t('publications.download')
								),
								downloadImage &&
									m(Image, {
										class: 'featuredpublication-inner-bottom-image',
										src: downloadImage,
										alt: 'Download PDF image'
									})
							]
						)
					])
			]),
			modTags &&
				m('.featuredpublication-outer-bottom', [
					m('.featuredpublication-outer-bottom-tags', [
						m('.featuredpublication-outer-bottom-tags-title',
							t('publications.themes')
						),
						this.viewThemes(policy, sector)
					]),
					m('.featuredpublication-outer-bottom-line'),
					m('.featuredpublication-outer-bottom-tags', [
						m('.featuredpublication-outer-bottom-tags-title',
							t('publications.tags')
						),
						this.viewTags(tags)
					])
				])
		])
	}
	viewThemes(policy: Array<string>, sector: Array<string>) {
		const {lists} = this.attrs
		const themes = getAllThemesFromLists(lists, policy, sector)
		return m('.featuredpublication-outer-bottom-tags-container',
			themes &&
				themes.map(theme => {
					return m(TagLink, {
						mod: 'tag',
						class: 'featuredpublication-outer-bottom-tags-container-tag',
						text: theme
					})
				})
		)
	}

	viewTags(tags: Array<string>) {
		const {lists} = this.attrs
		const themes = getAllTagsFromLists(tags, lists)
		return m('.featuredpublication-outer-bottom-tags-container',
			themes &&
				themes.map(tag => {
					return m(TagLink, {
						mod: 'tag',
						class: 'featuredpublication-outer-bottom-tags-container-tag',
						text: tag
					})
				})
		)
	}
	getCopy(channel: string, label: string) {
		switch (channel) {
			case 'publication':
				if (label == 'other') return t('publications.publication')
				return t('publications.paper')
			case 'article':
				return t('articles.publication')
			default:
				return t('home.featuredpositionpaper')
		}
	}
}
